import React, { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { X } from "lucide-react";

export function QrScanModal({ open, onClose, onScan }) {
  const scannerRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    const scanner = new Html5Qrcode("qr-reader");
    scannerRef.current = scanner;
    scanner
      .start(
        { facingMode: "environment" },
        { fps: 10, qrbox: 220 },
        (decoded) => {
          if (!cancelled) onScan(decoded);
        },
        () => {}
      )
      .catch((e) => console.warn("qr start failed", e));
    return () => {
      cancelled = true;
      try {
        scanner.stop().then(() => scanner.clear()).catch(() => {});
      } catch {
        /* ignore */
      }
    };
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] bg-black/80 flex items-center justify-center p-4" data-testid="qr-scan-modal">
      <div className="bg-white rounded-2xl p-4 w-full max-w-sm">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-black text-[#161629]">امسح رمز QR للمشتري</h3>
          <button data-testid="qr-scan-close" onClick={onClose}>
            <X size={22} />
          </button>
        </div>
        <div id="qr-reader" className="w-full rounded-xl overflow-hidden" />
        <p className="text-xs text-[#6B7280] text-center mt-3">وجّه الكاميرا نحو رمز QR الظاهر لدى المشتري</p>
      </div>
    </div>
  );
}
